import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";

import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  NavigateButton,
  DocPaper,
  DocLink
} from "../../../DocCreater";

function NotFoundStep(props) {
  return (
    <DocPaper>
      <Title>无此学习步骤</Title>
    </DocPaper>
  );
}

export default NotFoundStep;
